import forEach from 'lodash/forEach'

/*
    Each time a resource node is created an automatic fetch is triggered. This
    happens only once. We may want to adapt other fetching strategies as well.

    TODO: Resources would be problematic in a realtime scenario atm, as all
    collaborators would trigger a fetch of the resource, when it should only
    be done by the user who created the resource explicitly
*/

class DWResourceManager {

    constructor(editorSession) {
        this.editorSession = editorSession
        this.editorSession.onRender('document', this._onDocumentChange, this)
    }

    dispose() {
        this.editorSession.off(this)
    }

    /*
    Trigger fetch of a given resource
    */
    triggerFetch(resource, info) {
        info = info || {}

        /**
         * First argument to fetchPayload is "context" but is never used anywhere and probably should never be used anywhere
         * Keep it for backwards compatibility but add deprecation tag.
         *
         * @deprecated
         *
         */
        resource.fetchPayload(null, (err, props) => {
            if (err) {
                this._updateNode(resource.id, {
                    errorMessage: err.toString()
                }, info)
            } else {
                this._updateNode(resource.id, props, info)
            }
        })
    }

    _onDocumentChange(change) {
        let doc = this.editorSession.getDocument()
        forEach(change.created, (node) => {
            node = doc.get(node.id)
            if (node.constructor.isResource) {
                setTimeout(() => {
                    this.triggerFetch(node)
                })
            }
        })
    }

    /*
    Fill in node payload
    */
    _updateNode(nodeId, props, info) {
        let editorSession = this.editorSession
        editorSession.transaction((tx) => {
            forEach(props, (val, key) => {
                tx.set([nodeId, key], val)
            })
        }, info)
    }
}


export {DWResourceManager}
